/* API module for MaterialController */

import { api } from './http';
import { toApiError } from './errors';
import type {
  MaterialCreateRequestDTO,
  MaterialResponseDTO,
  MaterialUpdateRequestDTO,
} from './types';

export type Id = number;

export async function getAll(): Promise<MaterialResponseDTO[]> {
  try {
    const { data } = await api.get<MaterialResponseDTO[]>('Material');
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function getById(id: Id): Promise<MaterialResponseDTO> {
  try {
    const { data } = await api.get<MaterialResponseDTO>(`Material/${id}`);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function create(payload: MaterialCreateRequestDTO): Promise<MaterialResponseDTO> {
  try {
    const { data } = await api.post<MaterialResponseDTO, MaterialCreateRequestDTO>('Material', payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function update(id: Id, payload: MaterialUpdateRequestDTO): Promise<MaterialResponseDTO> {
  try {
    const { data } = await api.put<MaterialResponseDTO, MaterialUpdateRequestDTO>(`Material/${id}`, payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function remove(id: Id): Promise<void> {
  try {
    await api.delete<void>(`Material/${id}`);
  } catch (e) {
    throw toApiError(e);
  }
}
